export default __webpack_public_path__ + "static/media/avits-logo.dd523fa0.png";